/**
 * Created by Denis Kuzin on 09 june 2026
 */

const TreasureSearchWindow = Prefab.createWindow("treasuresearch", "treasuresearchwindow_prefab_json");
